import { DateForm } from "../../../../utils/medicalDocument/form";
import moment from "moment";
import { DatePicker } from "../../../../../utils/form";
import { Stack } from "@mui/material";
import _ from "lodash";
import RecurringSettings from "./RecurringSettings";

const recurringDefaultValues = {
  days: null,
  quantity: 1
};

export default wizardProps => {
  const minDate = moment();

  const DateFields = props => {
    return (
      <Stack spacing={4}>
        <DatePicker {...props} />
        <RecurringSettings wizardProps={wizardProps} {...props} />
      </Stack>
    );
  };

  return (
    <DateForm
      {...wizardProps}
      minDate={minDate}
      defaultValues={{ recurring: recurringDefaultValues }}
      DateFields={DateFields}
      formMapper={form => {
        const isRecurring = !!form.recurring.days;
        if (isRecurring) return form;
        return _.omit(form, "recurring");
      }}
    />
  );
};